export default __webpack_public_path__ + "static/media/020202202170102.024dccfb.png";